import { fetchTickets, deleteTicket } from "../features/tickets/ticketsThunks";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Tickets() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

 const { tickets, isLoading } = useSelector((state) => state.tickets);

  const [filters, setFilters] = useState({
   title: "", status: "all", search: "",
  });

  useEffect(() => { 
    dispatch(fetchTickets()); 
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({...filters,[name]: value,});
  };

  const filteredTickets = useMemo(() => {
    const searchText = filters.search.toLowerCase();

    return tickets
      .filter(
        (ticket) =>
          filters.status === "all" || ticket.status === filters.status
      )
      .filter(
        (ticket) =>
          ticket.priority.toLowerCase().includes(searchText) ||
          ticket.title.toLowerCase().includes(searchText) ||
          ticket.description.toLowerCase().includes(searchText)
      );
  }, [tickets, filters]); // change in tickets or filters will re compute the filteredTickets

  return (
    <div className="container mt-4">
      <h2>All Tickets</h2>

      {isLoading && <div className="text-center">Loading...</div>}


      <div className="row mb-3">
        <div className="col-md-8">
          <input
            name="search"
            className="form-control"
            placeholder="Search tickets..."
            value={filters.search}
            onChange={handleFilterChange}
          />
        </div>

        <div className="col-md-4">
          <select
            name="status"
            className="form-select"
            value={filters.status}
            onChange={handleFilterChange}
          >
            <option value="all">All Statuses</option>
            <option value="open">Open</option>
            <option value="in-progress">In Progress</option>
            <option value="closed">Closed</option>
          </select>
        </div>
      </div>

      {filters.status !== "all" && (
        <div className="mb-2">
          <strong>Status:</strong> {filters.status}
        </div>
      )}

      <table className="table table-hover">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Status</th>
            <th>Priority</th>
            <th>Create Date</th>
          </tr>
        </thead>
        <tbody>
          {filteredTickets.map((ticket) => (
            <tr key={ticket.id}>
              <td>{ticket.title}</td>
              <td>{ticket.description}</td>
              <td>{ticket.status}</td>
              <td>{ticket.priority}</td>
              <td className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => navigate(`/edit-ticket/${ticket.id}`)}
                >
                  Edit
                </button>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => dispatch(deleteTicket(ticket.id))}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}